import { memo } from "react";
import { Link } from "react-router-dom";

const PressCard = (props) => {
  const { data } = props;

  let img = `${data?.media}`;

  return (
    <div style={{ width: "350px" }}>
      <div className="press-image-wrapper">
        <img src={img} alt={data.title} className="press-image" />
      </div>
      <div className="mt-3">
        <div className="d-flex w-100 align-items-center gap-2">
          <div className="flex-grow-1">
            <h6 className="text-uppercase">{data?.title}</h6>
          </div>
          <div className="flex-shrink-0">
            <Link className="arrow-btn" to={`/press/${data._id}`}>
              <i className="fas fa-angle-right" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(PressCard);
